import { FC, ReactNode, createElement } from 'react';

import {
  ApplianceContextProvider,
  CookingAppliancesContextProvider,
  DishwasherContextProvider,
  DrawingShapeContextProvider,
  FabricCanvasProvider,
  OptionalProductContextProvider,
  PricedProductsContextProvider,
  ProductDetailsContextProvider,
  RefrigeratorContextProvider,
  SlabImgProvider,
} from '.';
import { ChipMinimizerProvider } from './chipMinimizerContext';
import { EstimateContextProvider } from './estimateContext';
import { FaucetContextProvider } from './faucetsContext';
import { NavigationContextProvider } from './navigationContext';
import { StoresContextProvider } from './storesContext';
import { UndoStackContextProvider } from './undoStackContext';

interface ComposeProvidersProps {
  providers: FC[];
  children?: ReactNode;
}

interface ContextProviderProps {
  children?: ReactNode;
}

const ComposeProviders = ({ providers, children }: ComposeProvidersProps) => (
  <>
    {providers.reduceRight(
      (acc, ContextProvider) => createElement(ContextProvider, null, acc),
      children
    )}
  </>
);

export const ContextProvider = ({ children }: ContextProviderProps) => {
  const providers: FC[] = [
    SlabImgProvider,
    DrawingShapeContextProvider,
    DishwasherContextProvider,
    RefrigeratorContextProvider,
    CookingAppliancesContextProvider,
    OptionalProductContextProvider,
    ChipMinimizerProvider,
    ApplianceContextProvider,
    FaucetContextProvider,
    ProductDetailsContextProvider,
    PricedProductsContextProvider,
    UndoStackContextProvider,
    FabricCanvasProvider,
    StoresContextProvider,
    NavigationContextProvider,
    EstimateContextProvider,
  ];

  return <ComposeProviders providers={providers}>{children}</ComposeProviders>;
};
